import { createSlice } from "@reduxjs/toolkit";

export const usersSlice = createSlice({
  name: "usersSlice",
  initialState: {
    users: [],
    refRoles: [],
    roles: [],
  },
  reducers: {
    addUsers: (state, data) => {
      state.users = data.payload;
    },
    setRoles: (state, data) => {
      state.roles = data.payload;
    },
    setRefRoles: (state, data) => {
      state.refRoles = data.payload;
    },
  },
});

export const usersState = (state) => state.usersSlice.users;
export const rolesState = (state) => state.usersSlice.roles;

export const { addUsers, setRoles, setRefRoles } = usersSlice.actions;

export default usersSlice.reducer;
